export const GPX = () => {
  return (
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 693.1 693.1"
    >
      <g id="Layer_1">
        <path
          className="st0"
          d="M451.1,104.6L346.6,0l-104.6,104.6c-37.9,37.9-37.9,99.5,0,137.4-37.9-37.9-99.5-37.9-137.4,0L0,346.6l104.6,104.6c37.9,37.9,99.5,37.9,137.4,0-37.9,37.9-37.9,99.5,0,137.4l104.6,104.6,104.6-104.6c37.9-37.9,37.9-99.5,0-137.4,37.9,37.9,99.5,37.9,137.4,0l104.6-104.6-104.6-104.6c-37.9-37.9-99.5-37.9-137.4,0,37.9-37.9,37.9-99.5,0-137.4ZM415.5,415.5c-38.1,38.1-99.8,38.1-137.8,0-38.1-38.1-38.1-99.8,0-137.8,38.1-38.1,99.8-38.1,137.8,0,38.1,38.1,38.1,99.8,0,137.8Z"
        />
      </g>
    </svg>
  );
};
